import { Controller } from '@hotwired/stimulus';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default class extends Controller {
  static targets = ['container', 'pagination', 'prevButton', 'nextButton'];

  connect() {
    this.initSwiper();
  }

  initSwiper() {
    if (this.swiper) return;

    this.swiper = new Swiper(this.containerTarget, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 20,
      effect: 'slide',
      direction: 'horizontal',
      loop: false,
      updateOnImagesReady: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: this.hasNextButtonTarget ? this.nextButtonTarget : null,
        prevEl: this.hasPrevButtonTarget ? this.prevButtonTarget : null,
      },
      pagination: {
        el: this.hasPaginationTarget ? this.paginationTarget : null,
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
        renderBullet: function (index, className) {
          return `<span class="${className}"></span>`;
        },
      },
    });
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
}
